<div *ngIf="isGridVisible">
  <div class="risk-grid-header">
    <div class="enrollee-info">
      <h3>Enrollee Information</h3>
      <div class="enrollee-details">
        <div class="detail-item">
          <span class="label">Name:</span>
          <span class="value">{{ getEnrolleeFullName() }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Date of Birth:</span>
          <span class="value">{{ getEnrolleeDOB() }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Total Packages Created:</span>
          <span class="value">{{ totalAuditPackagesCount }}</span>
        </div>
      </div>
    </div>
  </div>
  
  <app-basic-grid [configuration]="auditGridConfiguration"
                  [data]="gridData"
                  [refresh]="refreshGrid"
                  [actionTemplate]="actionItem">
  </app-basic-grid>
</div>

<ng-template #actionItem let-rowData>
  <app-audit-query-grid-action-risk [data]="rowData" [parentComponent]="this"></app-audit-query-grid-action-risk>
</ng-template>

<ng-template #auditReadyItem let-rowData>
  <app-audit-query-item-readiness [chaseDetailsForAudit]="rowData" [projectType]="ProjectType.RISK"></app-audit-query-item-readiness>
</ng-template>

<ng-template #userRankItem let-rowData>
  <app-audit-query-item-user-rank-risk [chaseDetailsForAudit]="rowData" [parentComponent]="this"></app-audit-query-item-user-rank-risk>
</ng-template>

<ng-template #chaseIdColumn let-rowData>
  <app-chase-grid-chase-id [isOverreadFeedbackEmpty]="true" [isCurrentUserAbstractorForOverreadFeedback]="false" [data]="rowData"
    chaseIdUrl="/members/chase/:chaseId"></app-chase-grid-chase-id>
</ng-template>